import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { LabelsTab } from '@/features/Transition360/Labels/LabelsTab';
import { LABELS_SCENARIOS } from '@/features/Transition360/Labels/fixtures';
import { useLabelsReviewState } from '@/features/Transition360/Labels/useLabelsReviewState';

const labelsSearchSchema = z.object({
    scenario: z.enum(LABELS_SCENARIOS).optional().catch(undefined),
});

export const Route = createFileRoute(
    '/transition-360/projects/$projectId/assets/$projectAssetId/labels',
)({
    validateSearch: labelsSearchSchema,
    component: LabelsTabRoute,
});

function LabelsTabRoute() {
    const { projectId } = Route.useParams();
    const { scenario } = Route.useSearch();
    const { tree, documentsByLeafId, config, saveTags } =
        useLabelsReviewState(scenario ?? 'review');
    return (
        <LabelsTab
            projectId={projectId}
            tree={tree}
            documentsByLeafId={documentsByLeafId}
            config={config}
            onSaveTags={saveTags}
        />
    );
}
